import './App.css';
import AdmissionForm from './Components/AdmissionForm';

function App() {
  return (
    <div className="App">
      <AdmissionForm />
    </div>
  );
}

export default App;
